import React from "react";
import {
  DataFlowsCollectionPageConfig,
  DataFlowsCollectionPageContent,
} from "../../../data-map/data-flows/DataFlowsCollectionPage";
import { Routes } from "../../../../root/routes";
import { HRDataMapTabs } from "./HRDataMapTabs";

export function HRDataFlowsCollectionPage() {
  const HR_DATA_FLOWS_COLLECTION_CONFIG: DataFlowsCollectionPageConfig = {
    collectionContext: ["EMPLOYEE"],
    orderingVariant: "employee",
    dashboardRoute: Routes.hrCenter.hrDataMap.dataFlows,
    breadcrumbSource: "Data Flows",
    breadcrumbSourceRoute: Routes.hrCenter.hrDataMap.dataFlows,
    headerElement: <HRDataMapTabs selectedTabKey="hr-data-flows" />,
  };

  return <DataFlowsCollectionPageContent config={HR_DATA_FLOWS_COLLECTION_CONFIG} />;
}
